import BookWithConfidence from "@sitewide/components/BookWithConfidence";
import SitewideAutocomplete from "@sitewide/components/SitewideAutocomplete";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "vite/modulepreload-polyfill";

import BookingDrawer from "@/booking/components/constructs/BookingDrawer";
import { BookingEvent } from "@/booking/eventEnums";
import { ColorEnum } from "@/enums";

import NewsLetter from "./components/NewsLetter";

ReactDOM.createRoot(document.querySelector(".header-sitewide")!).render(
  <React.StrictMode>
    <React.Suspense>
      <BrowserRouter>
        <SitewideAutocomplete
          color={ColorEnum.STEELBLUE}
          iconColor={ColorEnum.WHITE}
        />
      </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
);

ReactDOM.createRoot(document.querySelector(".nav-sitewide")!).render(
  <React.StrictMode>
    <React.Suspense>
      <BrowserRouter>
        <SitewideAutocomplete
          color={ColorEnum.STEELBLUE}
          iconColor={ColorEnum.WHITE}
          mobile
        />
      </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
);

const footerBannerElement = document.querySelector(".footer-enquiry-banner");
if (footerBannerElement) {
  ReactDOM.createRoot(footerBannerElement).render(
    <React.StrictMode>
      <React.Suspense>
        <BrowserRouter>
          <BookWithConfidence />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>,
  );
}

const onlineBookingElement = document.querySelector("#online-booking-root");

if (onlineBookingElement) {
  const root = ReactDOM.createRoot(onlineBookingElement);
  root.render(
    <React.StrictMode>
      <React.Suspense>
        <BookingDrawer />
      </React.Suspense>
    </React.StrictMode>,
  );

  const initOnlineBooking = () => {
    const buttons = document.querySelectorAll<HTMLButtonElement>(
      "[role='button'][data-target='#online-booking-modal']",
    );

    if (buttons.length) {
      buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          window.postMessage(
            {
              eventType: BookingEvent.OPEN_DRAWER,
              event: { packageId: button.dataset.packageId },
            },
            import.meta.env.VITE_API_HOST,
          );
        });
      });
    }
  };

  initOnlineBooking();
}

const newsletterElement = document.querySelector("#newsletter-form");
if (newsletterElement) {
  ReactDOM.createRoot(newsletterElement).render(
    <React.StrictMode>
      <React.Suspense>
        <BrowserRouter>
          <NewsLetter />
        </BrowserRouter>
      </React.Suspense>
    </React.StrictMode>,
  );
}
